import React, { Component, forwardRef } from "react"
import DatePicker from "react-datepicker"
import Svg from "../_svgs/svg"
import { isMobile } from "react-device-detect"

export default class SearchOverlay extends Component {
  constructor(props) {
    super(props)

    this.calendar = React.createRef()
  }

  componentDidMount() {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    })
  }

  handleDatepicker = () => {
    const openState = this.calendar.state.open
    this.calendar.setOpen(!openState)
    this.props.handleDatepicker()
  }

  handleOutsideClick = () => {
    this.calendar.setOpen(false)
    this.props.closeDatepicker()
  }

  render() {
    const CustomInput = forwardRef(({ value }, ref) => (
      <div className={"react-datepicker-ignore-onclickoutside"} onClick={this.handleDatepicker} ref={ref}>
        {value}
      </div>
    ))
    CustomInput.displayName = "CustomInput"

    const shortDateOptions = {
      month: "short",
      day: "2-digit",
    }

    const shortSearchDate = new Date(this.props.searchDate).toLocaleDateString(this.props.locale.code, shortDateOptions)
    const noResultsLabel =
      this.props.noResultsLabel?.replace("{input}", this.props.q).replace("{date}", shortSearchDate) ??
      `Ingen resultater matchede din søgning på "${this.props.q}"`
    const renderSearchResults = this.props.q && this.props.q.length >= (this.props.minCharsBeforeSearch ?? 2)
    const isOpen = this.props.q && this.props.q.length > 0

    const formattedDate = this.props.searchDate.toFormat("dd / MM / yyyy")
    const formattedTime = this.props.searchDate.toFormat("HH")

    const departuresTabIconColor = this.props.direction === "D" ? "#064FC2" : "#071143"
    const departuresTabIcon = (
      <Svg
        iconName={this.props.departuresTabIcon ? this.props.departuresTabIcon : "planetakeoff"}
        fillColor={"none"}
        stroke={departuresTabIconColor}
      />
    )
    const arrivalsTabIconColor = this.props.direction === "A" ? "#064FC2" : "#071143"
    const arrivalsTabIcon = (
      <Svg iconName={this.props.arrivalsTabIcon ? this.props.arrivalsTabIcon : "planelanding"} fillColor={"none"} stroke={arrivalsTabIconColor} />
    )

    return (
      <div className="form__section__inner">
        <div
          className={`search-overlay ${!isMobile && isOpen && !renderSearchResults ? "is-open" : ""} ${
            !isMobile && renderSearchResults ? "has-results" : !isMobile && !renderSearchResults ? "is-closed" : ""
          } ${this.props.showOverlay ? "" : "hide-overlay"} ${isMobile && this.props.showOverlay ? "mobile-open" : ""}`}
        >
          {!isMobile && this.props.q.length < (this.props.minCharsBeforeSearch ?? 2) ? (
            <div className="form__section__inner">
              <div className="search-results helper-text">
                <div className="flights__table stylish-table">
                  <div className="stylish-table__row stylish-table__row--body">
                    <p>
                      {this.props.searchHelperText ||
                        `Du skal minimum skrive ${this.props.minCharsBeforeSearch ?? 2} karakterer for at få resultater.`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className={`tabs ${isOpen && !renderSearchResults ? "is-round" : ""} `}>
                <a
                  className={`button button--medium has-icon no-shadow ${this.props.direction === "D" ? "is-active" : ""}`}
                  tabIndex="1"
                  onClick={() => this.props.handleDirectionChange("D")}
                  onTouchStart={() => this.props.handleDirectionChange("D")}
                >
                  {departuresTabIcon}
                  <span className="text">{this.props.departuresTabLabel || "Afgange"}</span>
                </a>
                <a
                  className={`button button--medium has-icon no-shadow ${this.props.direction === "A" ? "is-active" : ""}`}
                  tabIndex="2"
                  onClick={() => this.props.handleDirectionChange("A")}
                  onTouchStart={() => this.props.handleDirectionChange("A")}
                >
                  {arrivalsTabIcon}
                  <span className="text">{this.props.arrivalsTabLabel || "Ankomster"}</span>
                </a>
                <div className={`dateselect ${this.props.datepickerOpen ? "datepicker-open" : ""} ${!isMobile ? "is-desktop" : ""}`}>
                  <DatePicker
                    ref={(r) => (this.calendar = r)}
                    selected={this.props.searchDate.toJSDate()}
                    onChange={(date) => this.props.handleDateChange(date)}
                    showTimeSelect={this.props.showTime || false}
                    dateFormat="dd. MMM yyyy"
                    minDate={this.props.minDate.toJSDate()}
                    minTime={this.props.minTime.toJSDate()}
                    maxTime={this.props.maxTime.toJSDate()}
                    locale={this.props.locale}
                    customInput={<CustomInput calendar={this.calendar} />}
                    timeCaption={this.props.timeLabel || "Tidspunkt"}
                    timeIntervals={60}
                    onClickOutside={this.handleOutsideClick}
                    onCalendarClose={this.props.closeDatepicker}
                  />
                </div>
                <div className="clear"></div>
              </div>
              {(isMobile && renderSearchResults) || !isMobile ? (
                <div
                  className={`search-results ${isMobile && this.props.datepickerOpen ? "datepicker-open" : ""} ${
                    isMobile && this.props.showOverlay ? "make-sticky" : ""
                  }`}
                >
                  <div className="flights__table stylish-table">
                    {this.props.flights && this.props.flights.length > 0 ? (
                      this.props.flights.map((flight, index) => {
                        const currentUrl = this.props.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage
                        if (
                          (isMobile && index < (this.props.numberOfFlightsMobile || 10)) ||
                          (!isMobile && index < (this.props.numberOfFlights || 5))
                        ) {
                          const innerFlight = (
                            <>
                              <div className="stylish-table__cell flights__table__col--time">
                                <div>
                                  {flight.Delayed ? (
                                    <React.Fragment>
                                      <span className="t--strike">{`${flight.Time}`}</span>
                                      <span>
                                        <em>{`${flight.ExpectedTime}`}</em>
                                      </span>
                                    </React.Fragment>
                                  ) : (
                                    <span>
                                      <em>{`${flight.Time}`}</em>
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="stylish-table__cell flights__table__col--destination">
                                <div>
                                  <span className="v--desktop-only">
                                    <strong>
                                      <span>{flight.Destination}</span>
                                    </strong>
                                  </span>
                                  <span className="v--mobile-only">
                                    <strong>{flight.Destination}</strong> ({flight.IataDestination})
                                  </span>
                                  <span className="v--mobile-only">{flight.AirlineMobile ? flight.AirlineMobile : flight.Airline}</span>
                                </div>
                              </div>
                              <div className="stylish-table__cell flights__table__col--iataDestination v--desktop-only">
                                <div>
                                  <span>{flight.IataDestination}</span>
                                </div>
                              </div>
                              <div className="stylish-table__cell flights__table__col--carrier v--desktop-only">
                                <div>
                                  <span>
                                    <span>{flight.Airline}</span>
                                  </span>
                                </div>
                              </div>
                              <div className="stylish-table__cell flights__table__col--gate">
                                <div>
                                  <span>{flight.Iata}</span>
                                </div>
                              </div>
                            </>
                          )
                          if (this.props.flightClickHandler) {
                            return (
                              <a
                                key={index}
                                className="stylish-table__row stylish-table__row--body pointer"
                                onClick={(e) => this.props.flightClickHandler(e, flight)}
                              >
                                {innerFlight}
                              </a>
                            )
                          } else {
                            return (
                              <a
                                key={index}
                                className="stylish-table__row stylish-table__row--body pointer"
                                href={`${currentUrl}/${flight.Iata}?id=${flight.FlightId}`}
                              >
                                {innerFlight}
                              </a>
                            )
                          }
                        }
                        return
                      })
                    ) : (
                      <div className="stylish-table__row stylish-table__row--body no-results">{noResultsLabel}</div>
                    )}
                  </div>
                  {this.props.flights && this.props.flights.length > 0 ? (
                    <div className="see-more-link">
                      {(this.props.direction === "D" && this.props.seeMoreFlightsDepartures) ||
                      (this.props.direction === "A" && this.props.seeMoreFlightsArrivals) ? (
                        <a
                          href={`${this.props.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
                            this.props.q
                          }&date=${formattedDate}&time=${formattedTime}`}
                        >
                          <Svg iconName={"arrowright-slim"} fillColor={"none"} />
                          {this.props.direction === "D"
                            ? this.props.seeMoreFlightsDepartures.replace("{input}", this.props.q)
                            : this.props.seeMoreFlightsArrivals.replace("{input}", this.props.q)}
                        </a>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.airports && this.props.airports.length > 0 ? (
                    <div className={"all-flights"}>
                      <h3>{this.props.direction === "D" ? this.props.allFlightsTo : this.props.allFlightsFrom}</h3>
                      {this.props.airports.map((airport, index) => {
                        if (index >= this.props.allFlightsLimit) return
                        return (
                          <a
                            href={`${this.props.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
                              airport.Iata
                            }&date=${formattedDate}&time=${formattedTime}`}
                            key={airport.Iata + index}
                          >{`${airport.Name} (${airport.Iata})`}</a>
                        )
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.airlines && this.props.airlines.length > 0 ? (
                    <div className={"all-flights"}>
                      <h3>{this.props.allFlightsWithCarrier}</h3>
                      {this.props.airlines.map((airline, index) => {
                        if (index >= this.props.carriersLimit) return
                        return (
                          <a
                            href={`${this.props.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
                              airline.iata
                            }&date=${formattedDate}&time=${formattedTime}`}
                            key={airline.iata + index}
                          >{`${isMobile && airline.nameMobile ? airline.nameMobile : airline.name} (${airline.iata})`}</a>
                        )
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}
